import React from "react";
import {
  FaTint,
  FaBalanceScale,
  FaSearchDollar,
  FaCompressArrowsAlt,
  FaRocket,
  FaLayerGroup,
} from "react-icons/fa";

function PriceStability() {
  return (
    <>
      <div className="services-style-five-area default-padding bottom-less">
        <div className="container">
          <div className="left-heading">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <h4 className="sub-title">Xeer Features</h4>
                <div className="right">
                  <h2 className="title">
                    Why Crypto Market Making Service is Essential
                  </h2>
                  <p>
                    Crypto market making plays a crucial role in ensuring
                    healthy market dynamics, enabling smoother trading
                    experiences, and supporting the growth of the cryptocurrency
                    ecosystem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-style-five-items">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaTint size={48} color="#0a1f44" />
                  </div>
                  <h4>Liquidity Enhancement</h4>
                  <p>
                    Market making ensures that there are enough buy and sell
                    orders in the market, making it easier for traders to
                    execute their transactions without significantly affecting
                    the asset's price. This is especially important for new or
                    less liquid tokens, where trading activity might otherwise
                    be limited.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaBalanceScale size={48} color="#0a1f44" />
                  </div>
                  <h4>Price Stability</h4>
                  <p>
                    By continuously providing buy and sell orders, market makers
                    help minimize price volatility. This stability is crucial
                    for maintaining investor confidence and encouraging more
                    trading activity.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaSearchDollar size={48} color="#0a1f44" />
                  </div>
                  <h4>Efficient Price Discovery</h4>
                  <p>
                    Market makers contribute to a more accurate and fair price
                    discovery process. Their constant activity helps reflect
                    real market conditions, allowing traders to see true asset
                    values.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaCompressArrowsAlt size={48} color="#0a1f44" />
                  </div>
                  <h4>Reduced Slippage</h4>
                  <p>
                    With ample liquidity, traders experience less slippage—the
                    difference between the expected price of a trade and the
                    actual price—resulting in better execution prices and
                    overall trading experience.
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaRocket size={48} color="#0a1f44" />
                  </div>
                  <h4>Support for New Tokens</h4>
                  <p>
                    Newly launched cryptocurrencies often face challenges in
                    gaining traction. Market making services provide the
                    necessary liquidity to attract traders and encourage market
                    participation, facilitating a successful launch.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaLayerGroup size={48} color="#0a1f44" />
                  </div>
                  <h4>Market Depth</h4>
                  <p>
                    Market makers enhance the overall depth of the market,
                    meaning that larger orders can be executed without
                    drastically impacting the asset's price. This is
                    particularly important for institutional traders who may
                    wish to buy or sell significant volumes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PriceStability;
